import { Categories } from "@/constants/categories";
import useAppStore from "@/context/store";
import FavoriteBoardList from "@/pageComponents/FavoriteBoardList";
import FavoritePinList from "@/pageComponents/FavoritePinList";
import FavoriteUserList from "@/pageComponents/FavoriteUserList";
import { getFavoritePins } from "@/services";
import { isLogined } from "@/utils/server/isLogined";
import { Tabs } from "antd";
import classNames from "classnames";
import Head from "next/head";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.less";
const TabPane = Tabs.TabPane;

export default function Favorite(props) {
  const { serverPinList, serverBoardList, serverUserList } = props;
  const router = useRouter();
  const { urlname } = router.query;
  const tabId = props.tabId || "pins";
  const headerRef = useRef(null);
  const height = useAppStore((store) => store.headerHeight);
  const [showHeader, setShowHeader] = useState(false);

  const onChangeTab = useCallback(
    (tabId) => {
      router.push(
        tabId === "pins"
          ? `/favorite/${urlname}`
          : `/${tabId}/favorite/${urlname}`
      );
    },
    [router, urlname]
  );

  const category = useMemo(() => {
    return Categories.find((category) => category.value === urlname);
  }, [urlname]);

  useEffect(() => {
    const onScroll = () => {
      const rect = headerRef.current?.getBoundingClientRect();
      setShowHeader(rect?.bottom - height + 55 <= 0);
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [height]);

  return (
    <div className={styles.favorite + " calculateWrapper"}>
      <Head>
        <title>
          {category?.label}图片_{category?.label}素材下载-花瓣网
        </title>
        <meta
          name="description"
          content={`花瓣网为您推荐${category?.label}相关的图片素材资源，其中涵盖众多设计师收藏采集的${category?.label}相关图片素材资源。花瓣网, 设计师寻找灵感的天堂！`}
        />
        <meta
          name="keywords"
          content={`${category?.label},${category?.label}图片,${category?.label}素材,${category?.label}资源`}
        />
      </Head>
      <div
        className={classNames([
          styles.sticky,
          showHeader ? styles.show : null,
          "modalOpenWidth",
        ])}
        style={{
          top: `${height}px`,
        }}
      >
        <div className={styles.title}>{category?.label}</div>
      </div>
      <h1 className={styles.header} ref={headerRef}>
        {category?.label}
      </h1>
      <Tabs
        defaultActiveKey="user"
        activeKey={tabId}
        destroyInactiveTabPane={true}
        onChange={onChangeTab}
        centered
      >
        <TabPane tab="采集" key="pins">
          <FavoritePinList serverPinList={serverPinList} />
        </TabPane>
        <TabPane tab="画板" key="boards">
          <FavoriteBoardList serverBoardList={serverBoardList} />
        </TabPane>
        <TabPane tab="用户" key="users">
          <FavoriteUserList serverUserList={serverUserList} />
        </TabPane>
      </Tabs>
    </div>
  );
}
export async function getServerSideProps({ req, query }) {
  const { urlname } = query;
  let serverPinList = null;
  if (!isLogined(req) && !req.url.includes(".json")) {
    const result = await getFavoritePins({
      urlname,
      limit: 20,
    });
    serverPinList = result?.pins || [];
  }
  return {
    props: {
      serverPinList,
    },
  };
}
